import {useNavigate} from 'react-router-dom';
import {useState} from 'react';

import SignUpHeader from "./components/header";
import SignUpMain from "./components/main";
import Footer from '../../generals-components/footer/footer';

function SignUpPage() {
    const navigate = useNavigate();
    const [showAlertOK, setShowAlertOK] = useState(false)
    const [OKAlertText, setOKAlertText] = useState("")

    const [showAlertERROR, setShowAlertERROR] = useState(false)
    const [ERRORAlertText, setERRORAlertText] = useState("")

    const showAlert = (type, text) => {
        if (type === "error") {
            setShowAlertERROR(true)
            setERRORAlertText(text)

            setTimeout(function() {
                setShowAlertERROR(false)
            }, 3500)
        }
    }

    const handleSignup = async (dati) => {
        const response = await fetch('/api/signup', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dati),
        });

        const data = await response.json();

        if (response.ok) {
            setShowAlertOK(true)
            setOKAlertText("Created account " + dati.email + ", redirecting")
            
            setTimeout(function() {
                navigate('/login');
            }, 2500)
        } else {
            showAlert("error", data.detail.msg)
        }
    };

    return (
        <>
            <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden">
                <SignUpHeader/>
                <SignUpMain handleSignupData={handleSignup}/>
                <Footer/>
            </div>

            {showAlertOK && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-green text-sm right-[10px] top-[10px] select-none animate-[show-alert_3s_ease-in-out_forwards]">{OKAlertText}</span>}
            {showAlertERROR && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-red text-sm right-[10px] top-[10px] select-none animate-[show-alert_3s_ease-in-out_forwards]">{ERRORAlertText}</span>}
        </>
    );
}


export default SignUpPage;